/* src/app/shared/components/notifications/notification-icon/notification-icon.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.notification-icon {
  width: 1.25rem;
  height: 1.25rem;
  position: relative;
}
.notification-icon .material-icons {
  width: 1.25rem;
  height: 1.25rem;
  font-size: 1.25rem;
  color: #242424;
}
.notification-icon .material-icons.has-items {
  cursor: pointer;
  position: relative;
}
.notification-icon .material-icons.has-items::after {
  content: "";
  position: absolute;
  bottom: 1px;
  right: 0;
  display: block;
  height: 0.5rem;
  width: 0.5rem;
  border-radius: 50%;
  background-color: #d50000;
}
.notification-icon .message {
  position: absolute;
  top: 1.5rem;
  right: 0;
  font-size: 0.8125rem;
  width: 13.5rem;
  z-index: 9;
  background-color: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  overflow: hidden;
  height: 0;
  max-height: 0;
  visibility: hidden;
  opacity: 0;
  transition:
    max-height 0.3s ease-out,
    visibility 0.3s ease-out,
    opacity 0.3s ease-out;
}
.notification-icon .message.opened {
  padding: 1rem;
  height: auto;
  max-height: 500px;
  visibility: visible;
  opacity: 1;
}
.notification-icon .message.opened:focus {
  outline: none;
}
.notification-icon .message ::ng-deep a {
  color: inherit;
  font-weight: 700;
  text-decoration: underline;
}
.notification-icon .message ::ng-deep a:hover {
  color: inherit;
}
/*# sourceMappingURL=notification-icon.component.css.map */
